export const quoteSource = {
  online: "online",
};
